import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService, BrokerRequest } from '@c4/core';
import { C4Option } from '@c4/ui';

import { Room as BaseRoom, Device } from '../../common/interfaces/item.interface';
import { Command } from '../../common/params/interfaces/command.interface';
import { Binding } from '../../common/interfaces/binding.interface';
import { ItemsService } from './../../common/services/items.service';

interface MediaDevice {
  id: number;
  type: string;
  roomId: number;
  name: string;
  category: string[];
}

interface Media {
  roomId?: number;
  watch_devices: {
    visible: MediaDevice[],
  },
  listen_devices: {
    visible: MediaDevice[]
  }
}

interface Source {
  id: number;
  device_id: number;
  name: string;
  location: string;
  genre: string;
  description: string;
  img: string;
}

export interface Room extends BaseRoom {
  broadcast_audio?: Source[];
  broadcast_video?: Source[];
  albums?: Source[];
  playlists?: Source[];
  movies?: Source[];
  commands?: Command[];
}

export interface MediaProgrammingContext {
  rooms?: Room[];
  remotes?: Device[];
}

const COMMAND_WHITELIST = [
  'SELECT_AUDIO_MEDIA:PLAYLIST',
  'SELECT_AUDIO_MEDIA:ALBUM',
  'SELECT_AUDIO_MEDIA:MOVIE',
  'SELECT_AUDIO_MEDIA:BROADCAST_AUDIO',
  'SELECT_VIDEO_MEDIA:BROADCAST_VIDEO',
];

const INITIAL_STATE: MediaProgrammingContext = {}

const STORE_NAME = ['PROGRAMMING', 'QUICKSTARTS', 'MEDIA'].join(':');

export const MEDIA_ACTIONS = {
  SET_ROOMS: `${STORE_NAME}:SET_ROOMS`,
  SET_REMOTES: `${STORE_NAME}:SET_REMOTES`
}

const MEDIA_ACTION_STRINGS = Object.keys(MEDIA_ACTIONS).map(key => MEDIA_ACTIONS[key]);

export function mediaProgrammingReducers(state: MediaProgrammingContext = INITIAL_STATE, { type, payload }): MediaProgrammingContext {

  // if (MEDIA_ACTION_STRINGS.indexOf(type) > -1) {
  //   console.debug('DEBUG >> %s called with %O', type, payload);
  // }

  switch (type) {

    case MEDIA_ACTIONS.SET_ROOMS:
      return Object.assign({}, state, { rooms: payload });

    case MEDIA_ACTIONS.SET_REMOTES:
      return Object.assign({}, state, { remotes: payload });

    default:
      return state;
  }
}

@Injectable()
export class QSMediaService {

  constructor(
    private _store: Store<{
      mediaProgramming: MediaProgrammingContext
    }>,
    private _broker: BrokerService,
    private _items: ItemsService
  ) {
    this._broker.getObservable<Device[]>({
      path: '/api/v1/locations/rooms'
    })
      // .concatMap(rooms => Observable.combineLatest(
      //   rooms.map(r => this._attach(r, {
      //     path: `/api/v1/locations/rooms/${r.id}/media/broadcast_audio`
      //   }))
      // ))
      // .concatMap(rooms => Observable.combineLatest(
      //   rooms.map(r => this._attach(r, {
      //     path: `/api/v1/locations/rooms/${r.id}/media/broadcast_video`
      //   }))
      // ))
      // .concatMap(rooms => Observable.combineLatest(
      //   rooms.map(r => this._attach(r, {
      //     path: `/api/v1/locations/rooms/${r.id}/media/albums`
      //   }))
      // ))'
      // .concatMap(rooms => Observable.combineLatest(
      //   rooms.map(r => this._attach(r, {
      //     path: `/api/v1/locations/rooms/${r.id}/media/albums/playlists`
      //   }))
      // ))
      // .concatMap(rooms => Observable.combineLatest(
      //   rooms.map(r => this._attach(r, {
      //     path: `/api/v1/locations/rooms/${r.id}/media/movies`
      //   }))
      // ))
      .flatMap(rooms => this._attachEach(rooms, {
        path: '/api/v1/items/commands',
        queryString: {
          query: {
            deviceId: {
              '$in': rooms.map(room => room.id)
            },
            command: {
              '$in': COMMAND_WHITELIST
            }
          }
        }
      }))
      .subscribe(rooms => this._store.dispatch({
        type: MEDIA_ACTIONS.SET_ROOMS,
        payload: rooms
      }))

    this._items.itemsList.map(items => {
      return items.filter((item: Device) => {
        return ['control4_sr250', 'control4_sr150', 'control4_sr260'].indexOf(item.proxy) > -1
      })
    }).subscribe(remotes => this._store.dispatch({
      type: MEDIA_ACTIONS.SET_REMOTES,
      payload: remotes
    }));
  }

  private _attachEach = <T extends Device>(rooms: T[], request: BrokerRequest): Observable<T[]> => {
    let key = request.path.split('/').pop();
    return Observable.fromPromise(this._broker.call(request))
      .map((responses: {
        deviceId: number
      }[]) => {
        return rooms.map(room => {
          room[key] = responses.filter(r => r.deviceId == room.id);
          return room;
        })
      });
  }

  private _attach = (room: Room, request: BrokerRequest): Observable<Room> => {
    let key = request.path.split('/').pop();
    return Observable.fromPromise(this._broker.call(request))
      .take(1)
      .map(response => {
        room[key] = response
        return room;
      });
  }

  static composeField = (field: string, option: {}): string => {
    var tokens: string[] = field.split(/[{}]/);

    if (tokens.length === 1) return option[field];

    return tokens.slice(1, -1).map((token, i) => {
      if (i % 2 === 0) {
        return option[token];
      }

      return token;
    }).join("");
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-media/quickstart-media.service.ts